import React, { useMemo, useRef, useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

export default function ProcedureTypeGrid({
  showBusinessCheckBox,
  setBussinessCheckBox,
  showDetailCheckBox,
  setShowDetailCheckBox,
  fullScreenView,
  setFullScreenView,
  isReadOnly = false,
  data,
  copyProcedureDetails,
  setProcessDetails,
  tableData,
  checkBox,
  action,
  cellHead,
}) {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(gridRef);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [rowData, setRowData] = useState(data);
  const [open, setOpen] = useState(false);
  const [option, setOption] = useState();
  const [textEdit, setTextEdite] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const filterBusinessAndDetailMessage = () => {
    const procedureDetial = copyProcedureDetails;
    if (showBusinessCheckBox && showDetailCheckBox) {
      setProcessDetails(copyProcedureDetails);
    } else if (
      showBusinessCheckBox &&
      procedureDetial &&
      procedureDetial.length &&
      procedureDetial.length > 0
    ) {
      let procedureDetialUpdated = copyProcedureDetails;
      procedureDetialUpdated = procedureDetialUpdated.filter(
        (item) => item.processTypeCd === 'Business'
      );
      setProcessDetails(procedureDetialUpdated);
    } else if (
      showDetailCheckBox &&
      procedureDetial &&
      procedureDetial.length &&
      procedureDetial.length > 0
    ) {
      let procedureDetialUpdated = copyProcedureDetails;
      procedureDetialUpdated = procedureDetialUpdated.filter(
        (item) => item.processTypeCd === 'Detail'
      );
      setProcessDetails(procedureDetialUpdated);
    } else {
      setProcessDetails([]);
    }
  };
  useEffect(() => {
    filterBusinessAndDetailMessage();
  }, [showBusinessCheckBox, showDetailCheckBox]);

  const removeSelected = () => {
    const selectedRowNodes = gridApi.getSelectedNodes();
    const filteredData = rowData.filter((dataItem) => {
      return dataItem !== selectedRowNodes[0].data;
    });
    setRowData(filteredData);
    setOpen(false);
  };

  const savedata = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewHistory = (gridsApi) => {
    const selectedRow = gridsApi.getSelectedRows()?.[0]?.processDetailID;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        PROCESS_ID: `${selectedRow?.processId}`,
        PROCESS_DETAIL_NUM: `${selectedRow?.processDetailNum}`,
      });
    }
  };

  useEffect(() => {
    if (textEdit) {
      setOption('save');
      setOpen(true);
      setTextEdite(false);
    }
    setRowData(data);
  }, [tableData]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const saveText = 'Do you want do save change?';
  const deleteText = ' Do you want to Delete?';
  return (
    <div style={containerStyle}>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Alert
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {option === 'save' ? saveText : deleteText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
          <Button
            onClick={option === 'save' ? savedata : removeSelected}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <div className="clearfix" />
      <div className="row float-left">
        <div className="col-12 welcometxt">
          <p className="no-margin tbl-help-text ">
            {checkBox && !fullScreenView ? (
              <>
                <div
                  className="hide-on-print"
                  style={{
                    marginTop: '5px',
                    marginLeft: '15px',
                  }}
                >
                  <div
                    className="mui-custom-form no-margin min-md"
                    style={{ display: 'flex', width: '100%' }}
                  >
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Display Business Messages"
                        checked={
                          copyProcedureDetails &&
                          copyProcedureDetails.length &&
                          copyProcedureDetails.length > 0 &&
                          showBusinessCheckBox
                        }
                        disabled={
                          !(
                            copyProcedureDetails &&
                            copyProcedureDetails.length &&
                            copyProcedureDetails.length > 0
                          )
                        }
                        onChange={() => {
                          setBussinessCheckBox(!showBusinessCheckBox);
                        }}
                      />
                    </div>
                    <div
                      className="sub-radio text-black sub-label"
                      style={{ marginLeft: '10px', marginRight: '10px' }}
                    >
                      <FormControlLabel
                        control={<Checkbox color="primary" />}
                        label="Display Detail Messages"
                        checked={
                          copyProcedureDetails &&
                          copyProcedureDetails.length &&
                          copyProcedureDetails.length > 0 &&
                          showDetailCheckBox === true
                        }
                        disabled={
                          !(
                            copyProcedureDetails &&
                            copyProcedureDetails.length &&
                            copyProcedureDetails.length > 0
                          )
                        }
                        onChange={() => {
                          setShowDetailCheckBox(!showDetailCheckBox);
                        }}
                      />
                    </div>
                  </div>
                  <div />
                  {action}
                </div>
              </>
            ) : (
              <></>
            )}
          </p>
        </div>
      </div>
      <Grid
        gridHeight={fullScreenView ? '100vh' : 350}
        rowData={data}
        columnDefs={cellHead}
        data-testid="onEditingStopped"
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={tabToNextCell}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        noGlobalSort
        //handleViewHistory={handleViewHistory}
        fileName="Procedure Result"
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="PROCESS_DETAIL"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
}
